<script setup lang="ts">
import { useRouter } from 'vue-router'
import { ref, onMounted, watch } from 'vue'
import { useI18n } from 'vue-i18n';
import { loadSales } from '@/api/category';
import { useHead } from '@vueuse/head';
import BlackFriday from '@/components/BlackFriday.vue';
import ChristmasPromo from '@/components/ChristmasPromo.vue';


const { locale } = useI18n()

const router = useRouter()
const cat = ref(null);
const loaded = ref(false);
// we watch locale if it changes we reload the category
watch(locale, ()=>{
    loaded.value = false
    load_category()
})
// we watch the props.path if it changes we reload the category
function load_category(){
    loaded.value = false
    loadSales(locale.value).then((res)=>{
        cat.value = res
        setMeta()
        // we go back to top
        window.scrollTo(0, 0)
        loaded.value = true
    }).catch((err)=>{
        console.log(err)
        //router.push({name: '404'})
    })
}

function setMeta(){
    useHead({
        title: cat.value.meta.title,
        meta: [
            {
                name: 'description',
                content: cat.value.meta.description
            },
            {
                name: 'keywords',
                content: cat.value.meta.keywords
            }
        ]
    })
}

onMounted(()=>{
    load_category()
})

</script>
<template>
    <BlackFriday variant="compact" />
    <ChristmasPromo variant="compact" />
    <template v-if="!loaded">
    <v-skeleton-loader 
            type="image"
            max-width="100%"
            :loading="!loaded"
            >
            
        </v-skeleton-loader>
        <v-skeleton-loader
            class="mx-auto mt-4"
            type="card"
            :loading="!loaded"
            max-width="400">
       
        </v-skeleton-loader>
    </template>
    <template v-else>
        <div id="category_header">
            <img :src="cat.background" :alt="cat.name" />
            <h1>{{ cat.title }}</h1>
            <h2 v-if="cat.subtitle">{{ cat.subtitle }}</h2>
        </div>
        <div class="content my-8">
            <div v-for="(subcat, index) in cat.subCategories" :key="index" class="d-flex flex-wrap ga-4 justify-center w-100 flex-container">
                <h3 v-if="subcat.title" class="w-100 text-left pl-5">{{ subcat.title }}</h3>
                <h4 v-if="subcat.subtitle" class="w-100 text-left pl-5">{{ subcat.subtitle }}</h4>
                <div v-if="subcat.description" class="w-100 text-left pl-5" v-html="subcat.description"></div>
                <Category v-for="category in subcat.cats" :key="category.name" :title="category.name" :to="`/${locale}/category/${props.path.join('/')}/${category.link}`" :img="category.img" />
            </div>
            <div v-for="(product, index) in cat.products" :key="index" class="d-flex flex-wrap ga-4 justify-space-around w-100 flex-container">
                <h3 v-if="product.title" class="w-100 text-left pl-5">{{ product.title }}</h3>
                <h4 v-if="product.subtitle" class="w-100 text-left pl-5">{{ product.subtitle }}</h4>
                <div v-if="product.description" class="w-100 text-left pl-5" v-html="product.description"></div>
                <h3 v-if="product.promo_title" class="w-100 text-left pl-5 bg-red">{{ product.promo_title }}</h3>
                <ProductPreview v-for="prod in product.prods" :key="prod" :sku="prod.sku" :title="prod.title" :subtitle="prod.subtitle" :img="prod.img" />
                <ProductPreview v-for="prod in product.articles" :key="prod.article_id" :id="prod.id" :article_id="prod.article_id" :title="prod.title" :subtitle="prod.subtitle" :img="prod.img" />
            </div>  
        </div>

    </template>
</template>
<style lang="scss" scoped>
.flex-container{
    &:after, &:before{
        position: relative;
        content: '';
        height: 1px;
        width: 308px;
        visibility: hidden;

        order: 1000;
    }
}
#category_header{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    height: 190px;
    width: 100%;
    overflow: hidden;
    img{
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;
    }
    h1{
        position: relative;
        z-index: 2;
        padding-left: 1rem;
        color: white;
        text-align: left;
        max-width: 997px;
        color: #FFF;
        width: 100%;
        font-family: Montserrat;
        font-size: 30px;
        font-weight: 700;
        line-height: 36.57px;
        text-align: left;
        text-underline-position: from-font;
        text-decoration-skip-ink: none;

    }
    h2{
        position: relative;
        z-index: 2;
        padding-left: 1rem;
        color: white;
        text-align: left;
        max-width: 997px;
        color: #FFF;
        width: 100%;
        font-family: Montserrat;
        font-size: 20px;
        font-weight: 400;
        line-height: 25px;
        text-align: left;
        text-underline-position: from-font;
        text-decoration-skip-ink: none;

    }
}
.content{
    max-width: 1024px;
    margin: 0 auto;
}
@media only screen and (min-width : $responsive-point) {
    .content{
        //justify-content: flex-start;
    }
    #category_header{
        height: 340px;
        h1{
            font-size: 50px;
            line-height: 60.83px;
        }
        h2{
            font-size: 30px;
            line-height: 36.57px;
        }
    }
}

</style>

<route lang="yaml">
name: category_sales
props: true
meta:
    title: Category Kase
    layout: default
    middleware: guest
</route>